import { c as _c } from "react/compiler-runtime";
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
import { useTranslation } from 'react-i18next';
import { useCountryName } from '@/idv2/hooks/use-country-name';
import HeaderTitle from '../header-title';
type DesktopHeaderProps = {
  docName?: string;
  sideName?: string;
  country?: Iso3166TwoDigitCountryCode;
  isSelfie?: boolean;
};
const DesktopHeader = t0 => {
  const $ = _c(12);
  const {
    docName,
    sideName,
    country,
    isSelfie
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.desktop-header"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const getCountryName = useCountryName();
  let subtitle;
  let title;
  if ($[1] !== country || $[2] !== docName || $[3] !== getCountryName || $[4] !== isSelfie || $[5] !== sideName || $[6] !== t) {
    const countryName = getCountryName(country);
    title = `${docName}`;
    if (!docName || isSelfie) {
      title = `${sideName}`;
    } else {
      if (docName && sideName) {
        title = `${docName} · ${sideName}`;
      }
    }
    if (!isSelfie && countryName) {
      subtitle = t(_temp, {
        country: countryName
      });
    }
    $[1] = country;
    $[2] = docName;
    $[3] = getCountryName;
    $[4] = isSelfie;
    $[5] = sideName;
    $[6] = t;
    $[7] = subtitle;
    $[8] = title;
  } else {
    subtitle = $[7];
    title = $[8];
  }
  let t2;
  if ($[9] !== subtitle || $[10] !== title) {
    t2 = <HeaderTitle title={title} subtitle={subtitle} />;
    $[9] = subtitle;
    $[10] = title;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
export default DesktopHeader;
function _temp($) {
  return $.subtitle;
}